import * as React from "react";
import { cn } from "../../lib/cn";

export function Card({ className, ...props }) {
  return (
    <div
      className={cn(
        "bg-white rounded-3xl border border-brand-border shadow-soft p-7 md:p-8 hover:-translate-y-1 hover:shadow-softHover transition-all duration-200",
        className
      )}
      {...props}
    />
  );
}
